module.exports = __webpack_public_path__ + "media/images/plans/photo_studio/photo7-2-8fefb7d65a0455aa7e4b92648847d0c6.png";